<template>
  <div class="box">
    <h6 class="form-subtitle">
      {{ $t("titles.form_person_info") }}
      <template v-if="player">{{ $t("from_player") }}</template>
      <template v-if="type == 'staff'">{{ $t("from_staff") }}</template>
      <template v-if="type == 'acompanyant'">{{
        $t("from_companion")
      }}</template>
    </h6>

    <!-- NAME -->
    <div class="item">
      <label>{{ $t("params.name") }} <span class="obligatory">*</span> </label>
      <input
        v-bind:class="error.name ? 'input-error' : ''"
        type="text"
        v-model="input.name"
        class="upper"
        autocomplete="nope"
      />
    </div>

    <!-- SURNAME -->
    <div class="item">
      <label
        >{{ $t("params.surname") }} <span class="obligatory">*</span>
      </label>
      <input
        v-bind:class="error.surname ? 'input-error' : ''"
        type="text"
        v-model="input.surname"
        class="upper"
        autocomplete="nope"
      />
    </div>

    <!-- DNI -->
    <div class="item">
      <label
        >{{
          $t("params.dni") +
          " / " +
          $t("params.nie") +
          " / " +
          $t("params.passport")
        }}
        <span class="obligatory">*</span>
        <span class="obligatory error" v-if="error.invalit_dni">{{
          " " + $t("errors.invalit_dni")
        }}</span>
        <span class="obligatory error" v-if="error.invalit_nie">{{
          " " + $t("errors.invalit_nie")
        }}</span>
        <span class="obligatory error" v-if="error.duplicated_dni">{{
          " " + $t("errors.duplicated_dni")
        }}</span>
      </label>
      <div>
        <v-radio-group v-model="input.document_type" row>
          <v-radio :label="$t('params.dni')" value="1"></v-radio>
          <v-radio :label="$t('params.nie')" value="2"></v-radio>
          <v-radio :label="$t('params.passport')" value="3"></v-radio>
        </v-radio-group>
        <input
          v-if="input.document_type == '1'"
          v-bind:class="error.dni ? 'input-error' : ''"
          type="text"
          v-model="input.dni"
          :placeholder="$t('params.dni') + '  ' + $t('params.dni_format')"
          ref="dni"
          class="upper"
          autocomplete="nope"
        />
        <input
          v-if="input.document_type == '2'"
          v-bind:class="error.dni ? 'input-error' : ''"
          type="text"
          v-model="input.dni"
          :placeholder="$t('params.nie') + '  ' + $t('params.nie_format')"
          ref="dni"
          class="upper"
          autocomplete="nope"
        />
        <input
          v-if="input.document_type == '3'"
          v-bind:class="error.dni ? 'input-error' : ''"
          type="text"
          v-model="input.dni"
          :placeholder="$t('params.passport')"
          ref="dni"
          class="upper"
          autocomplete="nope"
        />
      </div>
    </div>

    <!-- BIRTHDAY -->
    <div class="item" id="birthday">
      <label
        >{{ $t("params.birthday") }}
        <span :class="{ obligatory: this.player }">*</span>
        <span
          class="obligatory error"
          v-if="error.category_year && !error.exception_limit"
          >{{ " " + $t("errors.category_year") + category.year }}</span
        >
        <span class="obligatory error" v-if="error.exception_limit">{{
          " " +
          $tc(
            "errors.exception_limit",
            parseInt(category.num_players_exception) - 1,
            { s: category.num_players_exception }
          ) +
          (category.year - 1)
        }}</span>
      </label>
      <!-- <input v-bind:class="error.birthday ? 'input-error' : ''" type="date" v-model="input.birthday" autocomplete="nope"> -->
      <v-menu
        v-model="dialog_birthday"
        autocomplete="nope"
        :close-on-content-click="false"
        :nudge-right="40"
        lazy
        transition="scale-transition"
        nopeset-y
        full-width
        min-width="290px"
      >
        <template v-slot:activator="{ on }">
          <!--
          <v-text-field
            v-model="input.parsedBirthday"
            prepend-icon="event"
            readonly
            v-on="on"
            class="shadow date-picker"
            :class="error.birthday ? 'error' : ''"
          ></v-text-field>
          -->
          <v-text-field
            prepend-icon="event"
            v-model="input.parsedBirthday"
            @click:prepend="dialog_birthday = true"
            :placeholder="'DD/MM/YYYY'"
            :class="error.birthday ? 'error' : ''"
          ></v-text-field>
        </template>
        <v-date-picker
          v-model="input.birthday"
          @input="(dialog_birthday = false), formatBirthday()"
        ></v-date-picker>
      </v-menu>
    </div>

    <!-- NACIONALITY -->
    <div class="item" id="nacionality" v-if="player">
      <label>{{ $t("params.nacionality") }}</label>
      <v-autocomplete
        :class="error.nacionality ? 'input-error' : ''"
        v-model="input.nacionality"
        :items="Object.values(countries)"
        item-text="name"
        item-value="id"
        no-data
        :browser-autocomplete="'asd2saS<'"
        hide-no-data
      >
      </v-autocomplete>
    </div>

    <!-- GENDER -->
    <div class="item">
      <label
        >{{ $t("params.gender") }}
        <span v-if="player" class="obligatory">*</span>
        <span v-if="error.invalit_gender" class="obligatory error">{{
          $t("errors.gender")
        }}</span>
      </label>
      <v-radio-group v-model="input.gender" row>
        <v-radio value="1">
          <template v-slot:label>
            <span :class="error.gender ? 'obligatory' : ''">{{
              $t("gender.male")
            }}</span>
          </template>
        </v-radio>
        <v-radio value="2">
          <template v-slot:label>
            <span :class="error.gender ? 'obligatory' : ''">{{
              $t("gender.female")
            }}</span>
          </template>
        </v-radio>
      </v-radio-group>
    </div>

    <div v-if="type == 'acompanyant'" class="item"></div>

    <template v-if="type == 'staff'">
      <!-- TOURNAMENT REPRESENTATIVE -->
      <div class="item">
        <label>{{ $t("params.tournament_representative") }}</label>
        <span class="obligatory" v-if="error.assigned_representative">{{
          $t("errors.assigned_representative")
        }}</span>
        <v-radio-group v-model="input.tournament_representative" row>
          <v-radio value="1">
            <template v-slot:label>
              <span
                :class="error.assigned_representative ? 'obligatory' : ''"
                >{{ $t("si") }}</span
              >
            </template>
          </v-radio>
          <v-radio value="0">
            <template v-slot:label>
              <span
                :class="error.assigned_representative ? 'obligatory' : ''"
                >{{ $t("no") }}</span
              >
            </template>
          </v-radio>
        </v-radio-group>
      </div>
      <div class="item"></div>
    </template>

    <h6 class="form-subtitle">
      {{ $t("titles.form_person_medical") }}
      <template v-if="player">{{ $t("from_player") }}</template>
    </h6>

    <div style="margin-bottom: 10px">
      <span v-html="$t('descriptions.medical_information')"></span>
    </div>
    <!-- ALERGY -->
    <div class="item" id="alergy">
      <label>{{ $t("params.alergy") }}</label>
      <v-select
        :class="error.alergy ? 'error' : ''"
        v-model="input.alergy"
        :items="Object.values(alergies)"
        item-text="name"
        item-value="id"
        multiple
        :browser-autocomplete="'asd2saS<'"
        ref="alergy"
        id="alergies"
        style="padding: 0"
        attach
      >
        <template v-slot:selection="data">
          <v-chip
            :selected="data.selected"
            close
            @input="removeAlergy(data.item)"
          >
            {{ $t("alergy." + data.item.name) }}
          </v-chip>
        </template>
        <template slot="item" slot-scope="data">
          {{ $t("alergy." + data.item.name) }}
        </template>
      </v-select>
    </div>

    <!-- Other allergies -->
    <div class="item">
      <label>{{ $t("params.other_allergies") }}</label>
      <input type="text" v-model="input.other_allergies" autocomplete="nope" />
    </div>

    <!-- Diet -->
    <!-- <div class="item">
      <label>{{$t('params.diet')}}</label>
      <select v-model="input.diet" >
          <option v-for="(value, key) in diets" :key="key" :value="key">
              {{$t(value.name)}}
          </option>
      </select>
    </div> -->

    <div class="item"></div>

    <template v-if="player">
      <h6 class="form-subtitle">{{ $t("documents.football_legal.header") }}</h6>

      <!-- DORSAL NUMBER -->
      <div class="item" v-if="player">
        <label
          >{{ $t("params.number") }}
          <!-- <span class="obligatory">*</span> -->
          <span
            class="obligatory error"
            v-if="error.number && !error.duplicate_number"
            >{{ " " + $t("errors.invalid_number") }}</span
          >
          <span class="obligatory error" v-if="error.duplicate_number">{{
            " " + $t("errors.duplicated_number")
          }}</span>
        </label>
        <span v-html="$t('descriptions.dorsal')"></span>
        <input
          v-bind:class="error.number ? 'input-error' : ''"
          type="number"
          v-model="input.number"
          autocomplete="nope"
        />
      </div>

      <!-- POSITION -->
      <div class="item" v-if="player">
        <label>{{ $t("params.position") }}</label>
        <select
          v-bind:class="error.position ? 'input-error' : ''"
          v-model="input.position"
          autocomplete="nope"
        >
          <option
            v-for="position in positions"
            v-bind:value="position.id"
            v-bind:key="position.id"
          >
            {{ $t(position.name) }}
          </option>
        </select>
      </div>
    </template>

    <!-- HEIGHT -->
    <!--
    <div class="item" v-if="player">
      <label>{{$t('params.altura')}}</label>
      <input type="number" v-model="input.altura" :placeholder="$t('params.altura')">
    </div>
    -->
    <!-- SWIM -->
    <!--
    <div class="item" v-if="player">
      <label>{{$t('swim')}}</label>
      <v-radio-group v-model="input.swim" row>
        <v-radio :label="$t('si')" value="1"></v-radio>
        <v-radio :label="$t('no')"  value="0"></v-radio>
      </v-radio-group>
    </div>
    -->

    <template v-if="type == 'staff'">
      <h6 class="form-subtitle">{{ $t("params.team_information") }}</h6>

      <!-- STAFF LEVEL -->
      <div class="item">
        <label>{{ $t("params.staff_level2") }}</label>
        <select v-model="input.staff_level" autocomplete="nope">
          <option
            v-for="level in staff_level"
            v-bind:value="level.id"
            v-bind:key="level.id"
          >
            {{ $t("staff_level." + level.name) }}
          </option>
        </select>
      </div>

      <!-- CONTACT TYPE -->
      <div class="item">
        <label
          >{{ $t("params.cargo") }} <span class="obligatory">*</span>
        </label>
        <select
          v-model="input.contact_type"
          autocomplete="nope"
          :class="{ 'input-error': error.contact_type }"
        >
          <option v-for="item in contact_type" :value="item.id" :key="item.id">
            {{ $t(item.name) }}
          </option>
        </select>
      </div>
    </template>

    <div class="item" v-if="type == 'acompanyant'"></div>

    <h6 class="form-subtitle">
      {{ $t("titles.form_person_contact") }}
      <template v-if="player && is_integra">{{
        $t("from_player_integra")
      }}</template>
      <template v-else-if="player">{{ $t("from_player") }}</template>
      <template v-if="type == 'staff'">{{ $t("from_staff") }}</template>
      <template v-if="type == 'acompanyant'">{{
        $t("from_companion")
      }}</template>
    </h6>

    <!-- PHONE -->
    <div class="item">
      <label
        >{{ $t("params.phone") }}
        <span
          v-if="['staff', 'acompanyant', 'responsable'].includes(type)"
          class="obligatory"
          >*</span
        >
        <span v-if="error.invalit_phone" class="obligatory">
          {{ $t("errors.phone") }}</span
        >
      </label>
      <vue-tel-input
        v-model="input.phone"
        @input="playerPhone"
        autocomplete="nope"
        style="border-color: transparent"
        :placeholder="''"
        :class="[
          error.invalit_phone ? 'input-error' : '',
          error.phone ? 'input-error' : '',
        ]"
        defaultCountry="ES"
        :inputOptions="{ showDialCode: true }"
      ></vue-tel-input>
    </div>

    <!-- PHONE2 -->
    <!--
    <div class="item">
      <label>{{$t('params.phone2')}}</label>
      <input type="tel" v-model="input.phone2" :placeholder="$t('params.phone2')">
    </div>
    -->

    <!-- EMAIL -->
    <div class="item">
      <label
        >{{ $t("params.email") }}
        <span
          v-if="
            ['staff', 'acompanyant', 'responsable'].includes(type) || is_integra
          "
          class="obligatory"
          >*</span
        >
        <span v-if="error.invalit_email" class="obligatory">
          {{ $t("errors.email") }}</span
        >
      </label>
      <input
        type="email"
        :class="error.email ? 'input-error' : ''"
        v-model="input.email"
        autocomplete="nope"
      />
    </div>

    <!-- EMAIL2 -->
    <!--
    <div class="item">
      <label>{{$t('params.email2')}}</label>
      <input type="email" v-model="input.email2" :placeholder="$t('params.email2')">
    </div>
    -->

    <!-- <h6 class="form-subtitle">{{ $t('titles.form_person_medical') }} <template v-if="player">{{$t('from_player')}}</template> </h6> -->

    <!-- MEDICAMENTO -->
    <!--
    <div class="item" id="medicamento" v-if="player">
      <label>{{$t('params.medicamento')}}</label>
      <div>
        <v-checkbox class="checkbox" v-model="input.b_medicamento"></v-checkbox>
        <input :disabled="!input.b_medicamento" type="text" :class="error.medicamento ? 'input-error' : ''" v-model="input.medicamento" :placeholder="$t('params.medicamento')" ref="medicamento">
      </div>
    </div>
    -->

    <!-- <div class="item" v-if="type != 'player'"></div> -->

    <!-- <h6 class="form-subtitle" v-if="player">{{ $t('titles.form_person_address') }}</h6> -->

    <!-- ADDRESS -->
    <!-- <div class="item" v-if="player">
      <label>{{$t('params.address')}}</label>
      <input type="text" v-model="input.address" autocomplete="nope">
    </div> -->

    <!-- CP -->
    <!-- <div class="item" v-if="player">
      <label>{{$t('params.cp')}}</label>
      <input type="number" v-model="input.cp" autocomplete="nope">
    </div> -->

    <!-- CITY -->
    <!-- <div class="item" v-if="player">
      <label>{{$t('params.city')}}</label>
      <input type="text" v-model="input.city" autocomplete="nope">
    </div> -->

    <!-- STATE -->
    <!-- <div class="item" v-if="player">
      <label>{{$t('params.state')}}</label>
      <input type="text" v-model="input.state" autocomplete="nope">
    </div> -->

    <!-- COUNTRY -->
    <!-- <div class="item" id="country" v-if="player">
      <label>{{$t('params.country')}}</label>
      <v-autocomplete
        :class="error.country ? 'input-error' : ''"
        v-model="input.country_id"
        :items="Object.values(countries)"
        item-text="name"
        item-value="id"
        no-data
        hide-no-data
        :browser-autocomplete="'asd2saS<'"
      >
      </v-autocomplete>
    </div> -->

    <div class="item"></div>

    <!-- <h6 class="form-subtitle" v-if="type == 'staff' || type=='player'">{{ $t('titles.form_person_team') }}</h6> -->
    <!-- <h6 class="form-subtitle" v-if="player">{{ $t('titles.form_person_responsable_one') }}</h6> -->
    <h6 class="form-subtitle" v-if="player">
      {{ $t("titles.form_person_responsable") }}
    </h6>
    <h6 v-if="player">
      {{ $t("params.responsable_one") }}<span class="obligatory">*</span>
    </h6>

    <!-- SELECT NEW RESPONSABLE OR EXISTING RESPONSABLE -->
    <div class="item" v-if="player">
      <span v-if="error.responsable_error" class="obligatory">
        {{ $t("errors.resposanble_error") }}</span
      >
      <v-radio-group v-if="false" v-model="new_responsable_1" row>
        <v-radio :label="$t('params.new_responsable')" value="1"></v-radio>
        <v-radio :label="$t('params.existing_responsable')" value="2"></v-radio>
      </v-radio-group>
    </div>

    <!-- SELECT EXISTING RESPONSABLE -->
    <div v-if="false && new_responsable_1 == 2 && player">
      <div class="item" v-if="Object.keys(responsables).length > 0">
        <select
          v-model="input.responsable_selected_1"
          autocomplete="nope"
          style="width: 80%"
        >
          <option
            v-for="responsable in responsables"
            v-bind:value="responsable.id"
            v-bind:key="responsable.id"
          >
            {{ responsable.name + " " + responsable.surname }}
          </option>
        </select>
        <img
          v-bind:src="'/img/edit-b.svg'"
          v-if="event.main_actions && input.responsable_selected_1"
          alt="edit"
          @click="editResponsable(input.responsable_selected_1)"
          style="width: 25px; margin-left: 10px; cursor: pointer"
        />
      </div>

      <div class="item" v-else>
        <select disabled>
          <option disabled selected>
            {{ $t("descriptions.no_responsables") }}
          </option>
        </select>
      </div>
    </div>

    <div v-if="(true || new_responsable_1 == 1) && player">
      <!-- RESPONSABLE NAME -->
      <div class="item">
        <label
          >{{ $t("params.name") }} <span class="obligatory">*</span>
        </label>
        <input
          type="text"
          v-model="input.responsable_1_name"
          class="upper"
          :class="error.responsable_1_name ? 'input-error' : ''"
          autocomplete="nope"
        />
      </div>

      <!-- RESPONSABLE SURNAME -->
      <div class="item">
        <label>
          {{ $t("params.surname") }} <span class="obligatory">*</span>
        </label>
        <input
          type="text"
          v-model="input.responsable_1_surname"
          class="upper"
          :class="error.responsable_1_surname ? 'input-error' : ''"
          autocomplete="nope"
        />
      </div>

      <!-- RESPONSABLE PHONE -->
      <div class="item">
        <label
          >{{ $t("params.phone") }} <span class="obligatory">*</span></label
        >
        <!-- <input type="tel" v-model="input.responsable_1_phone" autocomplete="nope"> -->
        <vue-tel-input
          v-model="input.responsable_1_phone"
          @input="responsable1Phone"
          autocomplete="nope"
          style="border: none"
          :placeholder="''"
          defaultCountry="ES"
          :inputOptions="{ showDialCode: true }"
        ></vue-tel-input>
      </div>

      <!-- RESPONSABLE PHONE2 -->
      <!--
      <div class="item">
        <label>{{$t('params.phone2')}}</label>
        <input type="tel" v-model="input.responsable_1_phone2" :placeholder="$t('params.phone2')">
      </div>
      -->

      <!-- RESPONSABLE EMAIL -->
      <div class="item">
        <label>
          {{ $t("params.email") }}
          <span v-if="error.responsable_1_email" class="obligatory">{{
            $t("errors.email")
          }}</span>
          <span v-else class="obligatory">*</span></label
        >
        <input
          type="email"
          :class="error.responsable_1_email ? 'input-error' : ''"
          v-model="input.responsable_1_email"
          autocomplete="nope"
        />
      </div>

      <!-- RESPONSABLE EMAIL2 -->
      <!--
      <div class="item">
        <label>{{$t('params.email2')}}</label>
        <input type="email" v-model="input.responsable_1_email2" :placeholder="$t('params.email2')">
      </div>
      -->

      <!-- RESPONSABLE DNI -->
      <div class="item">
        <label
          >{{
            $t("params.dni") +
            " / " +
            $t("params.nie") +
            " / " +
            $t("params.passport")
          }}
          <span class="obligatory">*</span>
          <span
            class="obligatory error"
            v-if="error.responsable_1_invalit_dni"
            >{{ " " + $t("errors.invalit_dni") }}</span
          >
          <span
            class="obligatory error"
            v-if="error.responsable_1_invalit_nie"
            >{{ " " + $t("errors.invalit_nie") }}</span
          >
        </label>
        <div>
          <v-radio-group v-model="input.responsable_1_document_type" row>
            <v-radio :label="$t('params.dni')" value="1"></v-radio>
            <v-radio :label="$t('params.nie')" value="2"></v-radio>
            <v-radio :label="$t('params.passport')" value="3"></v-radio>
          </v-radio-group>
          <input
            v-if="input.responsable_1_document_type == '1'"
            :class="error.responsable_1_dni ? 'input-error' : ''"
            type="text"
            v-model="input.responsable_1_dni"
            :placeholder="$t('params.dni') + '  ' + $t('params.dni_format')"
            ref="dni"
            class="upper"
            autocomplete="nope"
          />
          <input
            v-if="input.responsable_1_document_type == '2'"
            :class="error.responsable_1_dni ? 'input-error' : ''"
            type="text"
            v-model="input.responsable_1_dni"
            :placeholder="$t('params.nie') + '  ' + $t('params.nie_format')"
            ref="dni"
            class="upper"
            autocomplete="nope"
          />
          <input
            v-if="input.responsable_1_document_type == '3'"
            :class="error.responsable_1_dni ? 'input-error' : ''"
            type="text"
            v-model="input.responsable_1_dni"
            :placeholder="$t('params.passport')"
            ref="dni"
            class="upper"
            autocomplete="nope"
          />
        </div>
      </div>

      <div class="item"></div>
    </div>

    <!-- Responsable 2 -->

    <!-- <h6 class="form-subtitle" v-if="player">{{ $t('titles.form_person_responsable_two') }}</h6> -->
    <h6 v-if="player">{{ $t("params.responsable_two") }}</h6>

    <!-- SELECT NEW RESPONSABLE OR EXISTING RESPONSABLE -->
    <div class="item" v-if="player">
      <v-radio-group v-if="false" v-model="new_responsable_2" row>
        <v-radio :label="$t('params.new_responsable')" value="1"></v-radio>
        <v-radio :label="$t('params.existing_responsable')" value="2"></v-radio>
      </v-radio-group>
    </div>

    <!-- SELECT EXISTING RESPONSABLE -->
    <div v-if="false && new_responsable_2 == 2 && player">
      <div class="item" v-if="Object.keys(responsables).length > 0">
        <select
          v-model="input.responsable_selected_2"
          autocomplete="nope"
          style="width: 80%"
        >
          <option
            v-for="responsable in responsables"
            v-bind:value="responsable.id"
            v-bind:key="responsable.id"
          >
            {{ responsable.name + " " + responsable.surname }}
          </option>
        </select>
        <img
          v-bind:src="'/img/edit-b.svg'"
          v-if="event.main_actions && input.responsable_selected_2"
          alt="edit"
          @click="editResponsable(input.responsable_selected_2)"
          style="width: 25px; margin-left: 10px; cursor: pointer"
        />
      </div>

      <div class="item" v-else>
        <select disabled>
          <option disabled selected>
            {{ $t("descriptions.no_responsables") }}
          </option>
        </select>
      </div>

      <div class="item"></div>
    </div>

    <div v-if="(true || new_responsable_2 == 1) && player">
      <!-- RESPONSABLE NAME -->
      <div class="item">
        <label
          >{{ $t("params.name") }}
        </label>
        <input
          type="text"
          v-model="input.responsable_2_name"
          class="upper"
          :class="error.responsable_2_name ? 'input-error' : ''"
          autocomplete="nope"
        />
      </div>

      <!-- RESPONSABLE SURNAME -->
      <div class="item">
        <label>
          {{ $t("params.surname") }}
        </label>
        <input
          type="text"
          v-model="input.responsable_2_surname"
          class="upper"
          :class="error.responsable_2_surname ? 'input-error' : ''"
          autocomplete="nope"
        />
      </div>

      <!-- RESPONSABLE PHONE -->
      <div class="item">
        <label
          >{{ $t("params.phone") }} </label
        >
        <!-- <input type="tel" v-model="input.responsable_2_phone" autocomplete="nope"> -->
        <vue-tel-input
          v-model="input.responsable_2_phone"
          @input="responsable2Phone"
          autocomplete="nope"
          style="border: none"
          :placeholder="''"
          defaultCountry="ES"
          :inputOptions="{ showDialCode: true }"
        ></vue-tel-input>
      </div>

      <!-- RESPONSABLE PHONE2 -->
      <!--
      <div class="item">
        <label>{{$t('params.phone2')}}</label>
        <input type="tel" v-model="input.responsable_2_phone2" :placeholder="$t('params.phone2')">
      </div>
      -->
      <!-- RESPONSABLE EMAIL -->
      <div class="item">
        <label>{{ $t("params.email") }}</label>
        <input
          type="email"
          v-model="input.responsable_2_email"
          autocomplete="nope"
        />
      </div>

      <!-- RESPONSABLE EMAIL2 -->
      <!--
      <div class="item">
        <label>{{$t('params.email2')}}</label>
        <input type="email" v-model="input.responsable_2_email2" :placeholder="$t('params.email2')">
      </div>
      -->
      <!-- RESPONSABLE DNI -->
      <div class="item">
        <label
          >{{
            $t("params.dni") +
            " / " +
            $t("params.nie") +
            " / " +
            $t("params.passport")
          }}

          <span
            class="obligatory error"
            v-if="error.responsable_2_invalit_dni"
            >{{ " " + $t("errors.invalit_dni") }}</span
          >
          <span
            class="obligatory error"
            v-if="error.responsable_2_invalit_nie"
            >{{ " " + $t("errors.invalit_nie") }}</span
          >
        </label>
        <div>
          <v-radio-group v-model="input.responsable_2_document_type" row>
            <v-radio :label="$t('params.dni')" value="1"></v-radio>
            <v-radio :label="$t('params.nie')" value="2"></v-radio>
            <v-radio :label="$t('params.passport')" value="3"></v-radio>
          </v-radio-group>
          <input
            v-if="input.responsable_2_document_type == '1'"
            :class="error.responsable_2_dni ? 'input-error' : ''"
            type="text"
            v-model="input.responsable_2_dni"
            :placeholder="$t('params.dni') + '  ' + $t('params.dni_format')"
            ref="dni"
            class="upper"
            autocomplete="nope"
          />
          <input
            v-if="input.responsable_2_document_type == '2'"
            :class="error.responsable_2_dni ? 'input-error' : ''"
            type="text"
            v-model="input.responsable_2_dni"
            :placeholder="$t('params.nie') + '  ' + $t('params.nie_format')"
            ref="dni"
            class="upper"
            autocomplete="nope"
          />
          <input
            v-if="input.responsable_2_document_type == '3'"
            :class="error.responsable_2_dni ? 'input-error' : ''"
            type="text"
            v-model="input.responsable_2_dni"
            :placeholder="$t('params.passport')"
            ref="dni"
            class="upper"
            autocomplete="nope"
          />
        </div>
      </div>

      <div class="item"></div>
    </div>
    <ErrorPopup
      @close="closePopup()"
      @input="closePopup()"
      :dialog="dialog"
    ></ErrorPopup>

    <ImageRightPopup
      @close="closeImageRightPopup()"
      @send="sendImageRight()"
      @copy="copyLink()"
      :dialog="dialogImageRight"
      :type="player ? 1 : 2"
      :email="email_contact"
      :name="name_person"
      :link="link"
    ></ImageRightPopup>

    <v-snackbar
      v-model="snackbar"
      :timeout="timeout"
      :top="true"
      :vertical="false"
    >
      {{ text }}
      <v-btn
        style="color: red; font-weight: bold; font-size: 16px"
        flat
        @click="snackbar = false"
      >
        X
      </v-btn>
    </v-snackbar>

    <div class="actions">
      <div class="btn" id="cancel" @click="redirect()">{{ $t("cancel") }}</div>
      <div class="btn" id="addedit" @click="validate()">
        {{ update ? $t("update") : $t("add") }}
      </div>
    </div>
  </div>
</template>

<script>
/* global moment, isEmpty, validateDocument, validateEmail */
import i18n from '@/i18n'
import ErrorPopup from '@/components/ui/ErrorPopup.vue'
import ImageRightPopup from '@/components/ui/ImageRightPopup.vue'

export default {
  name: 'PersonAdd',
  props: [],
  components: {
    ErrorPopup,
    ImageRightPopup
  },
  data () {
    return {
      id_imagerights: false,
      player: false,
      countries: {},
      positions: {},
      staff_level: {},
      user: {},
      alergies: {},
      diets: {},
      contact_type: {},
      update: false,
      type: '',
      category: {},
      players_exception: 0,
      responsables: {}, // responsable list
      new_responsable_1: '2', // hide form responsable 1, default show
      new_responsable_2: '2', // hide form responsable 2, default show
      dialog: false,
      dialogImageRight: false,
      dialog_birthday: false,
      email_contact: '',
      name_person: '',
      image_right_status: false,
      link: '',
      team: {},
      input: {
        name: '',
        surname: '',
        phone: '',
        phone_aux: '',
        original_phone: '',
        // phone2: '',
        email: '',
        // email2: '',
        address: '',
        cp: '',
        city: '',
        state: '',
        dni: '',
        document_type: '1',
        b_alergy: false,
        alergy: '',
        other_allergies: '',
        diet: 'Z1NjenJhTWxQSmdjVkYwVG1JMVMrZz09',
        birthday: '',
        parsedBirthday: '',
        gender: '',
        status: 1,
        country_id: '',
        nacionality: '',
        team: '',
        number: '',
        position: '',
        // b_medicamento: false,
        // medicamento: '',
        // swim: false,
        // altura: '',
        staff_level: '',
        contact_type: '',
        tournament_representative: '0',
        responsable_1_name: '',
        responsable_1_surname: '',
        responsable_1_dni: '',
        responsable_1_document_type: '1',
        responsable_1_phone: '',
        responsable_1_phone_aux: '',
        responsable_1_original_phone: '',
        // responsable_1_phone2: '',
        responsable_1_email: '',
        // responsable_1_email2: '',
        responsable_2_name: '',
        responsable_2_surname: '',
        responsable_2_document_type: '1',
        responsable_2_dni: '',
        responsable_2_phone: '',
        responsable_2_phone_aux: '',
        responsable_2_original_phone: '',
        // responsable_2_phone2: '',
        responsable_2_email: '',
        // responsable_2_email2: '',
        responsable_selected_1: '', // id from responsable selected in list
        responsable_selected_2: '' // id from responsable selected in list
      },
      original_dni: '',
      error: {
        name: false,
        surname: false,
        dni: false,
        birthday: false,
        gender: false,
        invalit_gender: false,
        number: false,
        category_year: false,
        exception_limit: false,
        duplicate_number: false,
        invalit_dni: false,
        invalit_nie: false,
        duplicated_dni: false,
        alergy: false,
        // medicamento: false,
        invalit_phone: false,

        responsable_1_name: false,
        responsable_1_surname: false,
        responsable_1_dni: false,
        responsable_1_invalit_dni: false,
        responsable_1_invalit_nie: false,
        responsable_1_invalit_phone: false,
        responsable_1_email: false,

        responsable_2_name: false,
        responsable_2_surname: false,
        responsable_2_dni: false,
        responsable_2_invalit_dni: false,
        responsable_2_invalit_nie: false,
        responsable_2_invalit_phone: false,
        responsable_2_email: false,

        // staff
        phone: false,
        email: false,
        invalit_email: false,
        assigned_representative: false,
        contact_type: false,

        responsable_error: false
      },
      snackbar: false,
      text: 'HOLAAAA',
      timeout: 0
    }
  },
  computed: {
    event () {
      return this.$store.getters['getCurrentEvent']()
    },

    is_integra () {
      return this.category.name === 'INTEGRA'
    }
  },
  created () {
    // get user
    this.user = this.$store.getters['user/getUser']
    // save team id
    this.input.team = this.$route.params.id
    console.log(this.$route.name)
    // get type
    switch (this.$route.name) {
      case 'players_add':
      case 'player_edit':
        this.type = 'player'
        this.player = true
        break
      case 'staff_add':
      case 'staff_edit':
        this.type = 'staff'
        break
      case 'acompanyants_add':
      case 'acompanyant_edit':
        this.type = 'acompanyant'
        break
      case 'responsable_edit':
        this.type = 'responsable'
        break
    }

    var self = this
    // get countries, player positions and staff level
    this.$store.dispatch('loadTablesRelationship').then(function () {
      self.countries = self.$store.getters['getCountries']
      self.alergies = self.$store.getters['getAlergy']
      self.diets = self.$store.getters['getDiets']

      let result = {}

      if (self.type === 'staff') {
        // contact type
        let contactType = { ...self.$store.getters['getContactType'] }
        result = {}
        // loop contact_types
        for (let i in contactType) {
          // check if type is a team type
          if (
            +contactType[i].type === 2 &&
            contactType[i].name !== 'contact_type.jugador' &&
            contactType[i].name !== 'contact_type.acompanyant' &&
            contactType[i].name !== 'contact_type.responsable'
          ) {
            result[contactType[i].id] = contactType[i]
          }
        }
        self.contact_type = result

        // staff levels
        let staffLevel = { ...self.$store.getters['getStaffLevel'] }
        result = {}
        // loop levels
        for (let i in staffLevel) {
          // check if sport is the same as the event
          if (staffLevel[i].sport === self.user.event_sport) {
            // yes, save level
            result[staffLevel[i].id] = staffLevel[i]
          }
        }
        self.staff_level = result
      }

      if (self.type === 'player') {
        // player positions
        let playersPositions = {
          ...self.$store.getters['getPlayerPositions']
        }
        result = {}
        // loop positions
        for (let i in playersPositions) {
          // check if sport is the same as the event
          if (playersPositions[i].sport === self.user.event_sport) {
            // yes, save position
            result[playersPositions[i].id] = playersPositions[i]
          }
        }
        self.positions = result
      }
    })

    // check for update
    if (typeof this.$route.params.person_id !== 'undefined') {
      this.update = true

      // this.$route.name == "player_edit" ? this.type = "player" : this.type = "person";
      // this.type == "player" ? this.player = true : this.player = false;

      this.loadInformation(this.$route.params.person_id)
    } else {
      // load team information on insert
      this.$store
        .dispatch('team/loadTeam', { team_id: this.input.team })
        .then(function () {
          // get team information
          let team = self.$store.getters['team/getTeam']

          if (self.type === 'acompanyant' && !team.team.mode) {
            self.$router
              .push({ name: 'team', params: { id: team.team.id } })
              .catch()
          }

          // categories
          self.category = team.team.category
          // check if isset acompanyants
          if (Object.keys(team.acompanyants).length > 0) {
            // save acompanyants
            self.addResponsables(team.acompanyants)
          }
          // check if isset staff
          if (Object.keys(team.staff).length > 0) {
            // save staff
            self.addResponsables(team.staff)
          }
          self.team = team
        })
    }
  },
  methods: {
    scrollToErrors () {
      let aux = document.getElementsByClassName('input-error')
      if (aux[0]) {
        var scroll = {
          container: document.getElementById('main-content'),
          target: aux[0],
          offset: -100
        }
        this.$root.scrollTo(scroll)
      }
    },

    removeAlergy (item) {
      let index = this.input.alergy.indexOf(item.id)
      if (index >= 0) {
        let aux = JSON.parse(JSON.stringify(this.input.alergy))
        aux.splice(index, 1)
        this.input.alergy = aux
      }
    },

    editResponsable (id) {
      // let team = self.$store.getters["team/getTeam"];
      // const person = Object.keys(team.acompanyants).filter( p => return p.id == id )
      // if(person.length > 0){

      // } else {
      //     const person2 = Object.keys(team.staff).filter( p => return p.id == id )
      // }

      //   this.$router
      //     .push({
      //       name: "responsable_edit",
      //       params: {
      //         person_id: id,
      //       },
      //     })
      //     .catch();
      window.location.href =
        '/' +
        this.$root.formatEventUrl(this.event.name, this.event.edition) +
        '/responsable/' +
        id +
        '/edit'
    },

    showPopupImageRight (id) {
      //   this.closeForm();
      if (
        ['player', 'staff'].includes(this.type) &&
        this.image_right_status <= 0
      ) {
        var person
        if (this.type === 'player') {
          person = this.team.players[id] ? this.team.players[id] : false
        } else {
          person = this.team.staff[id] ? this.team.staff[id] : false
        }

        if (!person || parseInt(person.image_right_status) !== 1) {
          this.name_person = this.input.name + ' ' + this.input.surname
          this.email_contact = this.type === 'player' ? '' : this.input.email
          if (
            this.type === 'player' &&
            (!this.email_contact || this.email_contact === '')
          ) {
            if (
              !this.input.responsable_selected_1 &&
              !this.input.responsable_selected_2
            ) {
              if (this.input.responsable_1_email) {
                this.email_contact = this.input.responsable_1_email
              } else if (this.input.responsable_2_email) {
                this.email_contact = this.input.responsable_2_email
              } else {
                this.email_contact = this.input.email
              }
            } else if (
              this.input.responsable_selected_1
            ) {
              this.email_contact =
                this.responsables[this.input.responsable_selected_1].email
            } else if (
              this.input.responsable_selected_2
            ) {
              this.email_contact =
                this.responsables[this.input.responsable_selected_2].email
            } else {
              this.email_contact = this.input.email
            }
          }
          var self = this
          this.id_imagerights = id
          this.$store
            .dispatch('person/getLinkImageRight', {
              event_id: this.event.id,
              id: id,
              type: this.type,
              lang: this.user.language
            })
            .then((response) => {
              self.link = response
              self.dialogImageRight = true
            })
        } else {
          this.closeForm()
        }
      } else {
        this.closeForm()
      }
    },

    sendImageRight () {
      var self = this
      this.$store
        .dispatch('person/sendImageRight', {
          event_id: this.event.id,
          id: this.id_imagerights,
          type: this.type,
          lang: this.user.language
        })
        .then((response) => {
          self.dialogImageRight = false
          self.closeForm()
        })
    },

    copyLink () {
      this.snackbar = true
      this.text = i18n.t('image_right.link_copied')
    },

    closeForm () {
      var self = this
      var person = self.$store.getters['person/getPerson']
      if (person) {
        switch (self.type) {
          case 'player':
            self.$router
              .push({
                name: 'player',
                params: { person_id: person.id }
              })
              .catch()
            break
          case 'staff':
            self.$router
              .push({
                name: 'coach',
                params: { person_id: person.id }
              })
              .catch()
            break
          case 'responsable':
            self.$router
              .push({
                name: 'responsable',
                params: { person_id: person.id }
              })
              .catch()
            break
          case 'acompanyant':
            self.$router
              .push({
                name: 'acompanyant',
                params: { person_id: person.id }
              })
              .catch()
            break
        }
      } else {
        self.$router
          .push({ name: 'team', params: { id: self.input.team } })
          .catch()
      }
    },

    validate () {
      // validate
      var validate = true

      // validate name
      if (isEmpty(this.input.name)) {
        this.error.name = true
        validate = false
      } else {
        this.error.name = false
      }

      // validate surname
      if (isEmpty(this.input.surname)) {
        this.error.surname = true
        validate = false
      } else {
        this.error.surname = false
      }

      // validate dni
      if (isEmpty(this.input.dni)) {
        this.error.dni = true
        validate = false
      } else {
        this.error.invalit_dni = false
        this.error.invalit_nie = false
        this.error.dni = false
        // validate DNI
        if (+this.input.document_type === 1) {
          // invalit document
          if (!validateDocument(this.input.dni, 1)) {
            this.error.invalit_dni = true
            this.error.dni = true
            validate = false
            // valit document
          } else {
            this.error.invalit_dni = false
            this.error.dni = false
          }
        }
        // validate NIE
        if (+this.input.document_type === 2) {
          if (!validateDocument(this.input.dni, 2)) {
            this.error.invalit_nie = true
            this.error.dni = true
            validate = false
            // valit document
          } else {
            this.error.invalit_dni = false
            this.error.dni = false
          }
        }
      }

      // validate birthday
      if (isEmpty(this.input.birthday) && this.player) {
        this.error.birthday = true
        validate = false
      } else {
        this.error.birthday = false
      }

      // validate if is checked alergy
      /*
            if(this.input.b_alergy == 1){
              // validate if is selected one alergy
              this.input.alergy = this.input.alergy.join(',');

              if(isEmpty(this.input.alergy)){
                this.error.alergy = true;
                validate = false;
              } else {
                this.error.alergy = false;
              }
            } else {
              this.input.alergy = '';
              this.error.alergy = false;
            }
            */

      // validate alergy
      if (!Array.isArray(this.input.alergy)) {
        this.input.b_alergy = 0
      } else {
        this.input.b_alergy = 1
      }

      // validate optional fields

      // if(isEmpty(this.input.phone)) this.input.phone = '';

      this.error.invalit_phone = false

      if (
        this.input.phone !== this.input.original_phone ||
        !this.input.original_phone
      ) {
        if (
          !isEmpty(this.input.phone) &&
          Object.keys(this.input.phone_aux).length > 0
        ) {
          if (this.input.phone_aux.isValid) {
            this.input.phone = this.input.phone_aux.number.e164
          } else {
            this.error.invalit_phone = true
            validate = false
          }
        } else {
          this.input.phone = ''
        }
      }

      if (isEmpty(this.input.other_allergies)) this.input.other_allergies = ''
      // if(isEmpty(this.input.phone2))                        this.input.phone2                       = '';
      if (isEmpty(this.input.email)) this.input.email = ''
      // if(isEmpty(this.input.email2))                        this.input.email2                       = '';
      if (isEmpty(this.input.address)) this.input.address = ''
      if (isEmpty(this.input.cp)) this.input.cp = ''
      if (isEmpty(this.input.city)) this.input.city = ''
      if (isEmpty(this.input.state)) this.input.state = ''
      // if(isEmpty(this.input.birthday))                      this.input.birthday                     = '';
      if (isEmpty(this.input.gender)) this.input.gender = ''
      if (isEmpty(this.input.country_id)) this.input.country_id = ''
      if (isEmpty(this.input.nacionality)) this.input.nacionality = ''
      if (isEmpty(this.input.number)) this.input.number = ''
      if (isEmpty(this.input.position)) this.input.position = ''
      // if(isEmpty(this.input.altura))                        this.input.altura                       = '';
      if (isEmpty(this.input.staff_level)) this.input.staff_level = ''
      if (isEmpty(this.input.contact_type)) this.input.contact_type = ''

      // validate responsable 1
      let emptyResponsable1 = true

      isEmpty(this.input.responsable_1_name)
        ? (this.input.responsable_1_name = '')
        : (emptyResponsable1 = false)
      isEmpty(this.input.responsable_1_surname)
        ? (this.input.responsable_1_surname = '')
        : (emptyResponsable1 = false)
      isEmpty(this.input.responsable_1_dni)
        ? (this.input.responsable_1_dni = '')
        : (emptyResponsable1 = false)
      // if(isEmpty(this.input.responsable_1_document_type))     this.input.responsable_1_document_type    = '';

      if (!isEmpty(this.input.responsable_1_phone)) emptyResponsable1 = false

      if (
        this.input.responsable_1_phone !==
        this.input.responsable_1_original_phone
      ) {
        if (
          !isEmpty(this.input.responsable_1_phone) &&
          Object.keys(this.input.responsable_1_phone_aux).length > 0 &&
          this.input.responsable_1_phone_aux.isValid
        ) {
          this.input.responsable_1_phone =
            this.input.responsable_1_phone_aux.number.e164
        } else {
          this.input.responsable_1_phone = ''
        }
      }

      // if(isEmpty(this.input.responsable_1_phone2))          this.input.responsable_1_phone2         = '';
      // isEmpty(this.input.responsable_1_email)               ? this.input.responsable_1_email            = '' : emptyResponsable1 = false;
      if (
        isEmpty(this.input.responsable_1_email) ||
        !validateEmail(this.input.responsable_1_email)
      ) {
        this.input.responsable_1_email = ''
      } else {
        emptyResponsable1 = false
      }

      // validate responsable 1 information if isn't empty
      if (!emptyResponsable1) {
        // name
        if (isEmpty(this.input.responsable_1_name)) {
          this.error.responsable_1_name = true
          validate = false
        } else {
          this.error.responsable_1_name = false
        }

        // surname
        if (isEmpty(this.input.responsable_1_surname)) {
          this.error.responsable_1_surname = true
          validate = false
        } else {
          this.error.responsable_1_surname = false
        }

        // DNi
        if (isEmpty(this.input.responsable_1_dni)) {
          this.error.responsable_1_dni = true
          validate = false
        } else {
          this.error.responsable_1_invalit_nie = false
          this.error.responsable_1_dni = false
          this.error.responsable_1_invalit_dni = false
          // validate DNI
          if (+this.input.responsable_1_document_type === 1) {
            // invalit document
            if (!validateDocument(this.input.responsable_1_dni, 1)) {
              this.error.responsable_1_invalit_dni = true
              this.error.responsable_1_dni = true
              validate = false
              // valit document
            } else {
              this.error.responsable_1_invalit_dni = false
              this.error.responsable_1_dni = false
            }
          }
          // validate NIE
          if (+this.input.responsable_1_document_type === 2) {
            // invalit document
            if (!validateDocument(this.input.responsable_1_dni, 2)) {
              this.error.responsable_1_invalit_nie = true
              this.error.responsable_1_dni = true
              validate = false
              // valit document
            } else {
              this.error.responsable_1_invalit_nie = false
              this.error.responsable_1_dni = false
            }
          }
        }
      }

      // validate responsable 2
      let emptyResponsable2 = true

      isEmpty(this.input.responsable_2_name)
        ? (this.input.responsable_2_name = '')
        : (emptyResponsable2 = false)
      isEmpty(this.input.responsable_2_surname)
        ? (this.input.responsable_2_surname = '')
        : (emptyResponsable2 = false)
      isEmpty(this.input.responsable_2_dni)
        ? (this.input.responsable_2_dni = '')
        : (emptyResponsable2 = false)
      // if(isEmpty(this.input.responsable_1_document_type))     this.input.responsable_1_document_type    = '';

      if (!isEmpty(this.input.responsable_2_phone)) emptyResponsable2 = false

      if (
        this.input.responsable_2_phone !==
        this.input.responsable_2_original_phone
      ) {
        if (
          !isEmpty(this.input.responsable_2_phone) &&
          Object.keys(this.input.responsable_2_phone_aux).length > 0 &&
          this.input.responsable_2_phone_aux.isValid
        ) {
          this.input.responsable_2_phone =
            this.input.responsable_2_phone_aux.number.e164
        } else {
          this.input.responsable_2_phone = ''
        }
      }

      // if(isEmpty(this.input.responsable_1_phone2))          this.input.responsable_1_phone2         = '';
      // isEmpty(this.input.responsable_1_email)               ? this.input.responsable_1_email            = '' : emptyResponsable1 = false;
      if (
        isEmpty(this.input.responsable_2_email) ||
        !validateEmail(this.input.responsable_2_email)
      ) {
        this.input.responsable_2_email = ''
      } else {
        emptyResponsable2 = false
      }

      // validate responsable 1 information if isn't empty
      if (!emptyResponsable2) {
        // name
        if (isEmpty(this.input.responsable_2_name)) {
          this.error.responsable_2_name = true
          validate = false
        } else {
          this.error.responsable_2_name = false
        }

        // surname
        if (isEmpty(this.input.responsable_2_surname)) {
          this.error.responsable_2_surname = true
          validate = false
        } else {
          this.error.responsable_2_surname = false
        }

        // DNi
        if (isEmpty(this.input.responsable_2_dni)) {
          this.error.responsable_2_dni = true
          validate = false
        } else {
          this.error.responsable_2_invalit_nie = false
          this.error.responsable_2_dni = false
          this.error.responsable_2_invalit_dni = false
          // validate DNI
          if (this.input.responsable_2_document_type === 1) {
            // invalit document
            if (!validateDocument(this.input.responsable_2_dni, 1)) {
              this.error.responsable_2_invalit_dni = true
              this.error.responsable_2_dni = true
              validate = false
              // valit document
            } else {
              this.error.responsable_2_invalit_dni = false
              this.error.responsable_2_dni = false
            }
          }
          // validate NIE
          if (this.input.responsable_2_document_type === 2) {
            // invalit document
            if (!validateDocument(this.input.responsable_2_dni, 2)) {
              this.error.responsable_2_invalit_nie = true
              this.error.responsable_2_dni = true
              validate = false
              // valit document
            } else {
              this.error.responsable_2_invalit_nie = false
              this.error.responsable_2_dni = false
            }
          }
        }
      }

      // validate email
      const bAdult = moment(this.input.birthday, 'YYYY-MM-DD').isBefore(
        moment().subtract(18, 'years')
      )
      if (
        ['staff', 'acompanyant', 'responsable'].includes(this.type) ||
        bAdult
      ) {
        if (isEmpty(this.input.email)) {
          this.error.email = true
          validate = false
        } else {
          // validate email
          if (validateEmail(this.input.email)) {
            this.error.email = false
            this.error.invalit_email = false
          } else {
            validate = false
            this.error.email = true
            this.error.invalit_email = true
          }
        }
      } else {
        if (
          isEmpty(this.input.email) &&
          !this.input.responsable_selected_1 &&
          isEmpty(this.input.responsable_1_email)
        ) {
          this.error.email = true
          this.error.responsable_1_email = true
          validate = false
        }
        if (
          !this.input.responsable_selected_1 &&
          isEmpty(this.input.responsable_1_phone)
        ) {
          validate = false
        }
      }

      if (['staff', 'acompanyant', 'responsable'].includes(this.type)) {
        // validate phone
        if (isEmpty(this.input.phone)) {
          this.error.phone = true
          validate = false
        } else {
          this.error.phone = false
        }
      }
      if (this.type === 'staff') {
        // check if team has team representative, team representative input is checheck and team representative is diferent = error
        if (
          this.team.team.representative != null &&
          +this.input.tournament_representative === 1 &&
          this.$route.params.person_id !== this.team.team.representative.id
        ) {
          this.error.assigned_representative = true
          validate = false
        } else {
          this.error.assigned_representative = false
        }

        // validate contact_type
        if (isEmpty(this.input.contact_type)) {
          this.error.contact_type = true
          validate = false
        } else {
          this.error.contact_type = false
        }
      }

      // player
      if (this.player) {
        // validate gender
        if (isEmpty(this.input.gender)) {
          this.error.gender = true
          validate = false
        } else {
          this.error.gender = false
          this.error.invalit_gender = false

          // gender == 1 => male
          // gender == 2 => female
          // gender == 3 => both

          if (
            +this.category.gender === 2 &&
            this.category.gender !== this.input.gender
          ) {
            this.error.gender = true
            this.error.invalit_gender = true
            validate = false
          }
        }

        if (!isEmpty(this.input.number)) {
          this.error.number = false
          // validate number
          if (
            parseInt(this.input.number) >= 0 &&
            parseInt(this.input.number) <= 999
          ) {
            // get numbers of the team
            var numbers = this.$store.getters['team/getUniformNumbers']
            var exists = false
            for (let id in numbers) {
              // check if number is from another player
              console.log(this.input.number, numbers[id], this.$route.params.person_id, id);
              if (
                +this.input.number === +numbers[id] &&
                this.$route.params.person_id !== id
              ) {
                exists = true
              }
            }
            // the number is from another player
            if (exists) {
              this.error.number = true
              validate = false
              this.error.duplicate_number = true
              // valid number
            } else {
              this.error.number = false
              this.error.duplicate_number = false
            }
          } else {
            this.error.duplicate_number = false
            this.error.number = true
            validate = false
          }
        }

        /*
              // check for medicaments
              if(this.input.b_medicamento){
                 // validate if is any
                 if(isEmpty(this.input.medicamento)){
                   this.error.medicamento = true;
                   validate = false;
                 } else {
                   this.error.medicamento = false;
                 }
              } else {
                this.input.medicamento = '';
                this.error.medicamento = false;
              }
              */
        // check if birthday is not empty for validate
        if (!isEmpty(this.input.birthday)) {
          // validate player year
          if (!this.validatePlayerYear()) {
            validate = false
          }
        }

        if (
          isEmpty(this.input.responsable_1_email) &&
          this.input.responsable_selected_1 == null
        ) {
          validate = false
          this.error.responsable_error = true
        }
        // if all ok
        if (validate) {
          var self = this
          this.input.responsable_selected_1 = undefined
          this.input.responsable_selected_2 = undefined
          // insert
          if (!this.update) {
            // validar si el dni està duplicat
            if (this.player) {
              this.$store
                .dispatch('person/personValidteIfExists', {
                  dni: self.input.dni,
                  type: 'player'
                })
                .then(function () {
                  // duplicated
                  if (self.$store.getters['person/getPersonExists']) {
                    self.error.duplicated_dni = true
                    self.error.dni = true
                    self.dialog = true
                    // not duplicated
                  } else {
                    self.$store
                      .dispatch('person/addPlayer', { input: self.input })
                      .then(function (response) {
                        self.showPopupImageRight(response.data.id)
                      })
                  }
                })
            }

            // update
          } else {
            // dni changed
            if (this.original_dni !== this.input.dni.toUpperCase()) {
              this.$store
                .dispatch('person/personValidteIfExists', {
                  dni: this.input.dni,
                  type: 'player'
                })
                .then(function () {
                  // duplicated dni
                  if (self.$store.getters['person/getPersonExists']) {
                    self.error.duplicated_dni = true
                    self.error.dni = true
                    self.dialog = true
                    // dni ok
                  } else {
                    let id = self.$route.params.person_id
                    self.$store
                      .dispatch('person/updatePlayer', {
                        person_id: id,
                        input: self.input
                      })
                      .then(function () {
                        self.showPopupImageRight(id)
                      })
                  }
                })
              // el dni no ha canviat
            } else {
              let id = self.$route.params.person_id
              self.$store
                .dispatch('person/updatePlayer', {
                  person_id: id,
                  input: self.input
                })
                .then(function () {
                  self.showPopupImageRight(id)
                })
            }
          }
        } else {
          this.dialog = true
        }
      } else {
        if (validate) {
          // insert person
          self = this
          if (!self.update) {
            // validate if dni already exists
            self.$store
              .dispatch('person/addPerson', {
                type: self.type,
                input: self.input
              })
              .then(function (response) {
                self.showPopupImageRight(response.data.id)
              })

            // update person
          } else {
            if (this.input.dni.toUpperCase() !== this.original_dni) {
              this.$store
                .dispatch('person/personValidteIfExists', {
                  dni: this.input.dni
                })
                .then(function () {
                  // duplicated dni
                  if (self.$store.getters['person/getPersonExists']) {
                    self.error.duplicated_dni = true
                    self.error.dni = true
                    self.dialog = true
                    // dni ok
                  } else {
                    let id = self.$route.params.person_id
                    self.$store
                      .dispatch('person/updatePerson', {
                        person_id: id,
                        input: self.input,
                        type: self.type
                      })
                      .then(function () {
                        self.showPopupImageRight(id)
                      })
                  }
                })
            } else {
              let id = self.$route.params.person_id
              this.$store
                .dispatch('person/updatePerson', {
                  person_id: id,
                  input: self.input,
                  type: self.type
                })
                .then(function () {
                  // redirect
                  self.showPopupImageRight(id)
                })
            }
          }
        } else {
          this.dialog = true
        }
      }
    },
    // load information for update
    loadInformation (id) {
      var self = this
      // get player information
      if (this.type === 'player') {
        this.$store
          .dispatch('person/loadPlayer', { person_id: id })
          .then(function () {
            var data = self.$store.getters['person/getPerson']
            self.input.name = data.name
            self.input.surname = data.surname
            self.input.phone = data.phone != null ? data.phone : ''
            self.input.original_phone = self.input.phone
            // self.input.phone2           =   data.phone2;
            self.input.email = data.email
            // self.input.email2           =   data.email2;
            self.input.address = data.address
            self.input.cp = data.cp
            self.input.city = data.city
            self.input.state = data.state
            self.input.dni = data.dni
            self.original_dni = data.dni // backup original dni
            self.input.document_type = data.document_type
            self.input.b_alergy = data.b_alergy
            self.input.alergy = data.alergy
            self.input.birthday = data.birthday
            self.input.parsedBirthday = moment(
              self.input.birthday,
              'YYYY-MM-DD'
            ).format('DD/MM/YYYY')
            self.input.gender = data.gender
            self.input.status = 1
            self.input.country_id = data.country
            self.input.nacionality = data.nacionality
            self.input.team = data.team
            self.input.number = data.number
            self.input.position = data.position
            // self.input.b_medicamento    =   data.b_medicamento;
            // self.input.medicamento      =   data.medicamento;
            // self.input.swim             =   data.swim == true ? "1" : "0"
            // self.input.altura           =   data.altura;
            self.input.other_allergies = data.other_allergies
            self.input.diet = data.diet

            self.image_right_status = parseInt(data.image_right_status)
            // load team info
            self.$store
              .dispatch('team/loadTeam', { team_id: data.team })
              .then(function () {
                // get team information
                var team = self.$store.getters['team/getTeam']
                // categories
                self.category = team.team.category
                // check if isset acompanyants
                if (Object.keys(team.acompanyants).length > 0) {
                  // save acompanyants
                  self.addResponsables(team.acompanyants)
                }
                // check if isset staff
                if (Object.keys(team.staff).length > 0) {
                  // save staff
                  self.addResponsables(team.staff)
                }
                // check if isset responsable 1
                if (data.responsable1 != null) {
                  // check if responsable id is in the list
                  if (
                    typeof self.responsables[data.responsable1.id] !==
                    'undefined'
                  ) {
                    self.new_responsable_1 = '2'
                    self.input.responsable_selected_1 = data.responsable1.id
                    self.input.responsable_1_name = data.responsable1.name
                    self.input.responsable_1_surname =
                      data.responsable1.surname
                    self.input.responsable_1_dni = data.responsable1.dni
                    self.input.responsable_1_document_type =
                      data.responsable1.document_type
                    self.input.responsable_1_phone =
                      data.responsable1.phone != null
                        ? data.responsable1.phone
                        : ''
                    self.input.responsable_1_original_phone =
                      self.input.responsable_1_phone
                    // self.input.responsable_1_phone2        =   data.responsable1.phone2;
                    self.input.responsable_1_email = data.responsable1.email
                    // self.input.responsable_1_email2         =   data.responsable1.email2;
                  } else {
                    self.input.responsable_1_name = data.responsable1.name
                    self.input.responsable_1_surname =
                      data.responsable1.surname
                    self.input.responsable_1_dni = data.responsable1.dni
                    self.input.responsable_1_document_type =
                      data.responsable1.document_type
                    self.input.responsable_1_phone =
                      data.responsable1.phone != null
                        ? data.responsable1.phone
                        : ''
                    self.input.responsable_1_original_phone =
                      self.input.responsable_1_phone
                    // self.input.responsable_1_phone2        =   data.responsable1.phone2;
                    self.input.responsable_1_email = data.responsable1.email
                    // self.input.responsable_1_email2         =   data.responsable1.email2;
                    self.new_responsable_1 = '1'
                  }
                }
                if (data.responsable2 != null) {
                  // check if responsable id is in the list
                  if (
                    typeof self.responsables[data.responsable2.id] !==
                    'undefined'
                  ) {
                    self.new_responsable_2 = '2'
                    self.input.responsable_selected_2 = data.responsable2.id
                    self.input.responsable_2_name = data.responsable2.name
                    self.input.responsable_2_surname =
                      data.responsable2.surname
                    self.input.responsable_2_dni = data.responsable2.dni
                    self.input.responsable_2_document_type =
                      data.responsable2.document_type
                    self.input.responsable_2_phone =
                      data.responsable2.phone != null
                        ? data.responsable2.phone
                        : ''
                    self.input.responsable_2_original_phone =
                      self.input.responsable_2_phone
                    // self.input.responsable_2_phone2        =   data.responsable2.phone2;
                    self.input.responsable_2_email = data.responsable2.email
                    // self.input.responsable_2_email2         =   data.responsable2.email2;
                  } else {
                    self.input.responsable_2_name = data.responsable2.name
                    self.input.responsable_2_surname =
                      data.responsable2.surname
                    self.input.responsable_2_dni = data.responsable2.dni
                    self.input.responsable_2_document_type =
                      data.responsable2.document_type
                    self.input.responsable_2_phone =
                      data.responsable2.phone != null
                        ? data.responsable2.phone
                        : ''
                    self.input.responsable_2_original_phone =
                      self.input.responsable_2_phone
                    // self.input.responsable_2_phone2        =   data.responsable2.phone2;
                    self.input.responsable_2_email = data.responsable2.email
                    // self.input.responsable_2_email2         =   data.responsable2.email2;
                    self.new_responsable_2 = '1'
                  }
                }
                self.team = team
              })
          })
        // get person information
      } else {
        this.$store
          .dispatch('person/loadPerson', { person_id: id })
          .then(function () {
            var data = self.$store.getters['person/getPerson']
            self.input.name = data.name
            self.input.surname = data.surname
            self.input.phone = data.phone
            self.input.original_phone = self.input.phone
            // self.input.phone2                     =   data.phone2;
            self.input.email = data.email
            // self.input.email2                     =   data.email2;
            self.input.address = data.address
            self.input.cp = data.cp
            self.input.city = data.city
            self.input.state = data.state
            self.input.dni = data.dni
            self.original_dni = data.dni // backup original dni
            self.input.document_type = data.document_type
            self.input.b_alergy = data.b_alergy
            self.input.alergy = data.alergy
            self.input.birthday = data.birthday
            self.input.parsedBirthday = moment(
              self.input.birthday,
              'YYYY-MM-DD'
            ).format('DD/MM/YYYY')
            self.input.gender = data.gender
            self.input.status = 1
            self.input.country_id = data.country
            self.input.nacionality = data.nacionality
            self.input.team = data.team
            self.input.staff_level = data.nivel
            self.input.other_allergies = data.other_allergies
            self.input.diet = data.diet
            self.input.contact_type = data.contact_type_id
              ? data.contact_type_id
              : ''
            // load team info
            self.$store
              .dispatch('team/loadTeam', { team_id: data.team })
              .then(function () {
                // if(self.$route.name == 'responsable_edit'){
                //   var data = self.$store.getters['team/getTeam'];
                //   self.players = data.players;
                // }
                self.team = self.$store.getters['team/getTeam']
                // get team representative
                if (self.team.team.representative) {
                  self.input.tournament_representative =
                    String(self.$route.params.person_id) ===
                    String(self.team.team.representative.id)
                      ? '1'
                      : '0'
                }
              })
          })
      }
    },
    validatePlayerYear () {
      // year from input
      var year = moment(this.input.birthday, 'YYYY-MM-DD').year()
      // check if the birthday year of the player is smaller than the category year
      if (year < this.category.year) {
        this.error.birthday = true
        this.error.category_year = true
        this.error.exception_limit = false
        // exceptions example:
        // one category has a year, for example 2000.
        // In some categories a player born in year before can play, with a limit. for example a guy with a birthday 01/10/1999 is a valid player
        // in category we have a count category.num_players_exception.
        // A team can't have more exceptions players than the limit of the category.
        // Only players born after 1 of July can be exceptions players
        // check year is the year before the category year
        if (+this.category.year - +year === 1) {
          // ok, the year is the exception year.
          // now check if player is born between 01/07/exception_year - 31/12/exception_year
          // get the month
          var month = moment(this.input.birthday, 'YYYY-MM-DD').month()
          // check if month is after july
          // month in moment = 0-11
          if (month >= 0) {
            // get num_players_exception
            this.players_exception =
              this.$store.getters['team/getNumPlayersException']
            // ok the player is a valid exception player.
            // ok, the team doesn't have the limit of players exception
            if (
              this.players_exception.length <
              this.category.num_players_exception
            ) {
              // congrats! all ok!
              this.error.birthday = false
              this.error.category_year = false
              this.error.exception_limit = false
              return true
              // team can't have more exception players
            } else {
              if (!this.category.num_players_exception) {
                this.error.birthday = true
                return false
              } else {
                // check if player is an existing exception player
                var isAnExceptionPlayer = false
                for (let id in this.players_exception) {
                  // is an exception player
                  if (
                    this.$route.params.person_id === this.players_exception[id]
                  ) {
                    isAnExceptionPlayer = true
                  }
                }
                // is an existing exception player
                if (isAnExceptionPlayer) {
                  this.error.birthday = false
                  this.error.category_year = false
                  this.error.exception_limit = false
                  return true
                  // is not an existing exception player
                } else {
                  this.error.exception_limit = true
                  return false
                }
              }
            }
            // sorry but is not a valid player, show regular waring
          } else {
            return false
          }
          // the year is not in the exception year, so the player is not valid, show regular waring
        } else {
          return false
        }
        // valid player
      } else {
        this.error.birthday = false
        this.error.category_year = false
        this.error.exception_limit = false
        return true
      }
    },
    /**
     * @param list = staff or acompnayants
     */
    addResponsables (list) {
      // clone responsables
      var responsables = JSON.parse(JSON.stringify(this.responsables))
      // loop for list
      for (var i in list) {
        // check if staff is an adult
        if (moment().year() - moment(list[i].birthday).year() > 17) {
          // check if person is 18
          if (moment().year() - +moment(list[i].birthday).year() === 18) {
            // validate month and day if is 18 years
            if (
              moment().month() >= moment(list[i].birthday).month() &&
              moment().date() >= moment(list[i].birthday).date()
            ) {
              responsables[list[i].id] = list[i]
            }
            // more than 18
          } else {
            responsables[list[i].id] = list[i]
          }
        }
      }
      // save responsables
      this.responsables = responsables
    },

    closePopup () {
      this.dialog = false
    },

    closeImageRightPopup () {
      this.dialogImageRight = false
      this.closeForm()
    },

    playerPhone (input, oResult) {
      this.input.phone_aux = oResult
    },

    responsable1Phone (input, oResult) {
      this.input.responsable_1_phone_aux = oResult
    },

    responsable2Phone (input, oResult) {
      this.input.responsable_2_phone_aux = oResult
    },

    redirect () {
      switch (this.type) {
        case 'player':
          !this.update
            ? this.$router.push({
              name: 'players',
              params: { team_id: this.$route.params.id }
            })
            : this.$router.push({
              name: 'player',
              params: { person_id: this.$route.params.person_id }
            })
          break
        case 'staff':
          !this.update
            ? this.$router.push({
              name: 'staff',
              params: { team_id: this.$route.params.id }
            })
            : this.$router.push({
              name: 'coach',
              params: { person_id: this.$route.params.person_id }
            })
          break
        case 'acompanyant':
          !this.update
            ? this.$router.push({
              name: 'acompanyants',
              params: { team_id: this.$route.params.id }
            })
            : this.$router.push({
              name: 'acompanyant',
              params: { person_id: this.$route.params.person_id }
            })
          break
      }
    },

    formatBirthday () {
      this.input.parsedBirthday = moment(this.input.birthday).format(
        'DD/MM/YYYY'
      )
    }
  },
  watch: {
    new_responsable_1: function () {
      if (+this.new_responsable_1 === 1) {
        this.input.responsable_selected_1 = ''
      }
      if (+this.new_responsable_1 === 2) {
        // remove information
        this.input.responsable_1_name = ''
        this.input.responsable_1_surname = ''
        this.input.responsable_1_dni = ''
        this.input.responsable_1_document_type = '1'
        this.input.responsable_1_phone = ''
        // this.input.responsable_1_phone2         =   '';
        this.input.responsable_1_email = ''
        // this.input.responsable_1_email2         =   '';
        // remove errors
        this.error.responsable_1_name = false
        this.error.responsable_1_surname = false
        this.error.responsable_1_dni = false
        this.error.responsable_1_invalit_dni = false
        this.error.responsable_1_invalit_nie = false
        this.error.responsable_1_invalit_phone = false
      }
    },
    new_responsable_2: function () {
      if (+this.new_responsable_2 === 1) {
        this.input.responsable_selected_2 = ''
      }
      if (+this.new_responsable_2 === 2) {
        // remove information
        this.input.responsable_2_name = ''
        this.input.responsable_2_surname = ''
        this.input.responsable_2_dni = ''
        this.input.responsable_2_document_type = '1'
        this.input.responsable_2_phone = ''
        // this.input.responsable_2_phone2         =   '';
        this.input.responsable_2_email = ''
        // this.input.responsable_2_email2         =   '';
        // remove errors
        this.error.responsable_2_name = false
        this.error.responsable_2_surname = false
        this.error.responsable_2_dni = false
        this.error.responsable_2_invalit_dni = false
        this.error.responsable_2_invalit_nie = false
        this.error.responsable_2_invalit_phone = false
      }
    },

    'input.parsedBirthday': function () {
      if (moment(this.input.parsedBirthday, 'DD/MM/YYYY').isValid()) {
        this.input.birthday = moment(
          this.input.parsedBirthday,
          'DD/MM/YYYY'
        ).format('YYYY-MM-DD')
      }
    }
  },
  mounted () {
    // check if alergy is false
    /*
        if(this.input.b_alergy == false && typeof this.$refs["alergy"] !== 'undefined'){
          this.$refs["alergy"].disabled = true;
        }
        */
    // check if medicamento is false
    /*
        if(this.player && this.input.b_medicamento == false && typeof this.$refs["medicamento"] !== 'undefined'){
          this.$refs["medicamento"].disabled = true;
        }
        */
  },
  updated () {
    /*
        let aux = Object.values(this.error);
        if ( aux.indexOf(true) != -1 ) {
          this.scrollToErrors();
        }
        */
  }
}
</script>

<style lang="scss" scoped>
#content.addedit-person {
  .box {
    width: 100% !important;
    max-width: 900px;
    margin-top: 25px !important;

    .message.input-error {
      color: $warning-color;
    }

    .upper {
      text-transform: uppercase;
      &::placeholder {
        text-transform: none;
      }
    }

    /* Alergy */
    .v-menu__content {
      margin-top: 43px;
    }

    .item {
      width: 50%;
      margin: 0px 0px 20px 0px;
      padding: 0 15px;
      display: inline-block;

      label {
        font-size: 14px;
        padding: 0;
        margin: 2px 0;
        display: block;
        font-weight: bold;
      }

      .v-radio {
        margin-right: 15px;
      }

      .v-input {
        margin-top: 0;
      }
      .v-input__slot {
        margin-bottom: 0;
      }

      input,
      select,
      .v-autocomplete .v-input__slot,
      .v-select {
        width: 100%;
        padding: 10px;
        // margin-bottom: 5px;
        border: 1px solid $secondary-color;
        outline: none;
        font-size: 16px;
        border-radius: 3px;
        color: $dark-color;

        &::placeholder {
          color: $dark-color;
          opacity: 0.5;
        }
      }

      input:disabled,
      select:disabled,
      .v-input--is-disabled {
        @include opacity(0.3);
      }

      .v-autocomplete {
        margin-top: 0;
        padding-top: 0;

        .v-input__control {
          .v-input__slot {
            margin: 0;
            padding: 4px;

            &:after,
            &:before {
              content: "";
              border: none !important;
            }
          }
          .v-select__slot {
            border: none;

            input {
              border: none;
              margin: 0;
            }
          }
        }
      }

      .obligatory {
        color: $alert-color;
        font-weight: bold;
        font-size: 16px;

        &.error {
          display: block;
        }
      }

      .input-error {
        border: 1px solid;
        border-color: $alert-color !important;
        &::placeholder {
          color: $alert-color !important;
          opacity: 0.5;
        }
        .v-input__slot {
          border-color: $alert-color;
        }
      }
    }

    .error {
      border-color: red !important;

      &::placeholder {
        color: $alert-color !important;
        opacity: 1;
      }

      .v-input__slot {
        border-color: $alert-color;
      }

      .vti__input {
        border-color: red !important;
      }
    }

    .date-picker.error {
      input {
        border: 1px solid red;
      }
    }

    #medicamento,
    #alergy {
      input[type="text"],
      select,
      .v-select {
        display: inline-block;
        width: calc(100% - 40px);
      }

      .checkbox {
        display: inline-block;
        width: 40px;
        height: 40px;
      }
    }

    #alergy {
      ::before {
        display: none;
      }

      .v-select .v-input__slot {
        padding: 6px;
        height: 42px;
      }

      .v-chip .v-chip__content {
        height: 26px;
      }

      .v-text-field__details {
        display: none !important;
      }

      .v-input {
        width: 100% !important;
      }

      input {
        border: none;
      }

      .v-input__control {
        padding: 0;
      }

      .v-input__slot {
        height: auto !important;
      }
    }

    #birthday {
      .error {
        input {
          border: 1px solid red;
        }
      }
    }

    #country,
    #nacionality {
      .v-select {
        padding: 0;
      }
      .v-autocomplete {
        border: none;
      }
    }

    select {
      background-image: url("/img/sort-down.svg");
      background-size: 10px;
      background-position: right 10px center;
      background-repeat: no-repeat;
    }

    select option {
      font-size: 14pt;
    }

    button.btn {
      max-width: 300px;
      width: 100%;
      padding: 15px;
      outline: none;
      border: none;
      cursor: pointer;
      font-size: 12pt;
      font-family: Speedee-Bold;
      margin-top: 25px;
      border-radius: 3px;
      border: 1px solid $secondary-color;
      text-transform: uppercase;
      transition: all 0.5s;
      background: #222;
      color: $secondary-color;

      &:hover {
        background: $main-color;
      }
    }

    .form-subtitle {
      margin-top: 36px;
      background: #eee;
      padding: 7px;

      &:first-of-type {
        margin-top: 12px;
      }
    }
  }
}

@include media("<=desktop") {
  #content.addedit-person {
    .box {
      width: 100%;
      padding: 0;
      margin: 0;

      .item {
        width: 100%;
        display: block;
      }
    }
  }
}
</style>

<style lang="scss" scoped>
.actions {
  padding: 25px;
  margin: 0 auto;
  margin-bottom: 25px;
  text-align: center;

  .btn {
    width: calc(50% - 20px);
    margin: 0 10px;
    display: inline-block;
    min-width: 40px;
    padding: 0 35px;
    outline: none;
    border: none;
    cursor: pointer;
    text-align: center;
    font-size: 16px;
    border-radius: 3px;
    -webkit-transition: all 0.5s;
    transition: all 0.5s;
    background-color: #172654;
    color: #fff;
    height: 40px;
    line-height: 40px;
    text-transform: uppercase;
    background-color: #fc8926;
    font-family: AvantGarde-Bold;
    max-width: 300px;
    transition: background-color 0.5s ease;

    &#addedit {
      border: 1px solid #fc8926;

      &:hover {
        background-color: #e78026;
        border-color: #e78026;
      }
    }

    &#cancel {
      background-color: transparent;
      color: #c55c00;
      border: 1px solid #fc8926;

      &:hover {
        background-color: #fc8a2623 !important;
      }
    }
  }
}

@include media("<=desktop") {
  .actions {
    padding: 25px 0px;

    .btn {
      padding: 0 15px;
    }
  }
}
</style>
<style lang="scss">
#content.addedit-person {
  .v-snack__content {
    background-color: #ee7e1c !important;
    color: #000;
    font-family: "Roboto-Light";
    font-size: 16px;
  }
}
</style>
